<script setup>
const isLocked = prebook_admin.is_pro != 1
</script>

<template>
    <!-- badge 'Upcoming'  -->
    <div v-if="isLocked" class="absolute rounded z-40 top-0 left-0 w-full h-full bg-white/70 flex items-center justify-center">
        <span class="text-white text-sm font-medium bg-[#7f56d9] px-5 py-1.5 rounded-full shadow-md" v-html="$slots.default || 'Upcoming'"></span>
    </div>
</template>